import { waitForHeritage } from '@atlassian/jira-common-bridge';

export const waitForLegacyConnectWRM = (timeout: number) =>
	Promise.race([
		waitForHeritage(),
		new Promise<void>((_, reject) =>
			setTimeout(() => reject(new Error('timeout waiting for heritage batch')), timeout),
		),
	]);
